var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    notificationContent: true,
    displayNotification: _vm.notification.display,
    successNotification: _vm.notification.type === 'success',
    errorNotification: _vm.notification.type === 'error',
  }},[_vm._v(" "+_vm._s(_vm.notification.details)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }